// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__0+JJf","jello-horizontal":"Button_jello-horizontal__bQgbu"};